import { colors } from "../../Styles";

export function Location({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <polygon points="127.79 171.47 156.71 171.47 162.03 150.26 133.11 150.26 127.79 171.47"/>
      <path d="M144.77,28.06c-40.61,0-73.53,32.92-73.53,73.53,0,70.25,62.73,160.4,73.53,160.4s73.53-89.32,73.53-160.4c0-40.61-32.92-73.53-73.53-73.53ZM144.77,144.68c-24.9,0-45.09-20.19-45.09-45.09s20.19-45.09,45.09-45.09,45.09,20.19,45.09,45.09-20.19,45.09-45.09,45.09Z"/>
    </svg>
  );
}
